import { createUseStyles } from 'react-jss'

export default createUseStyles({
  ctaForm: {
    marginTop: 15
  }
})
